import { useTranslation } from "react-i18next";

import { useRequiredContext } from "@lib/utils";

import { HaNResultList } from "../shared/HaNResultList/HaNResultList";
import { HaNContext } from "../shell/HaNContext";
import { FacilityCategoryEntryRows } from "./components/FacilityCategoryEntryRows";
import { FacilityCategoryGrid } from "./components/FacilityCategoryGrid";
import { FacilityCategoryGridSkeleton } from "./components/FacilityCategoryGridSkeleton";
import { FacilityCategoryHeader } from "./components/FacilityCategoryHeader";
import { FacilityCategoryOnOtherFloors } from "./components/FacilityCategoryOnOtherFloors";
import { useFacilitiesModel } from "./useFacilitiesModel";

export const FacilitiesList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "facilities") return null;

  return <FacilitiesListContent />;
};

const FacilitiesListContent = () => {
  const { t } = useTranslation();
  const { isLoading, categories, category, openCategory, entriesOnFloor, otherFloors } = useFacilitiesModel();

  if (isLoading) return <FacilityCategoryGridSkeleton />;
  if (categories.length === 0) return <HaNResultList.Empty text={t("hereAndNow:NoFacilitiesInBuilding")} />;

  if (!category) {
    return (
      <FacilityCategoryGrid
        categories={categories}
        onOpen={openCategory}
      />
    );
  }

  return (
    <>
      <FacilityCategoryHeader
        category={category}
        onBack={() => openCategory(null)}
      />

      {entriesOnFloor.length > 0 ? (
        <FacilityCategoryEntryRows entries={entriesOnFloor} />
      ) : (
        <HaNResultList.Empty text={t("hereAndNow:NoneOnFloor")} />
      )}

      <FacilityCategoryOnOtherFloors floors={otherFloors} />
    </>
  );
};
